export default "__VITE_ASSET__B6qA1A2t__"